import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, FileText, Search, Download, Check, X } from 'lucide-react';
import { DataTable } from '../components/DataTable';
import { StatusBadge } from '../components/StatusBadge';
const logs = [{
  id: 'LOG-9921',
  user: 'Admin User',
  role: 'Super Admin',
  action: 'Approved Rider',
  target: 'John Doe',
  ip: '192.168.1.1',
  status: 'success',
  time: '2 min ago'
}, {
  id: 'LOG-9920',
  user: 'Support Agent',
  role: 'Support',
  action: 'Refund Processed',
  target: 'TRX-8919',
  ip: '192.168.1.45',
  status: 'success',
  time: '15 min ago'
}, {
  id: 'LOG-9919',
  user: 'System',
  role: 'System',
  action: 'Auto-Payout Batch',
  target: 'Batch #402',
  ip: 'System',
  status: 'success',
  time: '2 hours ago'
}, {
  id: 'LOG-9918',
  user: 'Admin User',
  role: 'Super Admin',
  action: 'Suspended Rider',
  target: 'Bruce Wayne',
  ip: '192.168.1.1',
  status: 'warning',
  time: '3 hours ago'
}, {
  id: 'LOG-9917',
  user: 'Unknown',
  role: 'Unknown',
  action: 'Failed Login Attempt',
  target: 'Admin Panel',
  ip: '45.22.11.90',
  status: 'danger',
  time: '5 hours ago'
}, {
  id: 'LOG-9916',
  user: 'Manager',
  role: 'Admin',
  action: 'Updated Commission Rate',
  target: 'Global Settings',
  ip: '192.168.1.12',
  status: 'success',
  time: '1 day ago'
}];
const roles = [{
  name: 'Super Admin',
  permissions: [true, true, true, true, true, true]
}, {
  name: 'Admin',
  permissions: [true, true, true, true, true, false]
}, {
  name: 'Support',
  permissions: [false, true, false, true, false, false]
}, {
  name: 'Viewer',
  permissions: [false, false, false, false, true, true]
}];
const permissionNames = ['Manage Riders', 'Manage Users', 'Process Payments', 'Override PINs', 'Export Data', 'View Audit Logs'];
export function AuditLogs() {
  const columns = [{
    header: 'Log ID',
    accessor: 'id',
    className: 'font-mono text-xs'
  }, {
    header: 'User / Actor',
    accessor: (row: any) => <div className="flex items-center gap-2" data-id="element-102">
          <div className="w-6 h-6 rounded-full bg-slate-200 flex items-center justify-center text-xs font-bold text-slate-600" data-id="element-103">
            {row.user.charAt(0)}
          </div>
          <div className="flex flex-col" data-id="element-104">
            <span className="font-medium text-slate-700" data-id="element-105">{row.user}</span>
            <span className="text-[10px] text-slate-400 uppercase" data-id="element-106">
              {row.role}
            </span>
          </div>
        </div>
  }, {
    header: 'Action',
    accessor: 'action'
  }, {
    header: 'Target',
    accessor: 'target'
  }, {
    header: 'IP Address',
    accessor: 'ip',
    className: 'font-mono text-xs text-slate-500'
  }, {
    header: 'Status',
    accessor: (row: any) => <span className={`px-2 py-1 rounded-full text-xs font-medium ${row.status === 'success' ? 'bg-green-100 text-green-700' : row.status === 'warning' ? 'bg-yellow-100 text-yellow-700' : 'bg-red-100 text-red-700'}`} data-id="element-107">
          {row.status.toUpperCase()}
        </span>
  }, {
    header: 'Timestamp',
    accessor: 'time'
  }];
  return <div className="space-y-6" data-id="element-108">
      <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-100" data-id="element-109">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6" data-id="element-110">
          <div data-id="element-111">
            <h2 className="text-lg font-bold text-slate-800 flex items-center gap-2" data-id="element-112">
              <Shield className="text-famo-gold" size={24} data-id="element-113" />
              Security & Compliance Logs
            </h2>
            <p className="text-sm text-slate-500 mt-1" data-id="element-114">
              Monitor all administrative actions and system events.
            </p>
          </div>
          <div className="flex gap-2" data-id="element-115">
            <button className="px-4 py-2 bg-slate-50 border border-slate-200 rounded-lg text-sm font-medium text-slate-700 hover:bg-slate-100 flex items-center gap-2" data-id="element-116">
              <Download size={16} data-id="element-117" />
              Export CSV
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6" data-id="element-118">
          <div className="relative" data-id="element-119">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 h-4 w-4" data-id="element-120" />
            <input type="text" placeholder="Search logs..." className="w-full pl-10 pr-4 py-2 bg-slate-50 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-famo-gold/50" data-id="element-121" />
          </div>
          <select className="bg-slate-50 border border-slate-200 rounded-lg text-sm px-3 py-2 outline-none focus:ring-2 focus:ring-famo-gold/50" data-id="element-122">
            <option data-id="element-123">All Actions</option>
            <option data-id="element-124">User Management</option>
            <option data-id="element-125">Financial</option>
            <option data-id="element-126">Security</option>
          </select>
          <select className="bg-slate-50 border border-slate-200 rounded-lg text-sm px-3 py-2 outline-none focus:ring-2 focus:ring-famo-gold/50" data-id="element-127">
            <option data-id="element-128">Last 24 Hours</option>
            <option data-id="element-129">Last 7 Days</option>
            <option data-id="element-130">Last 30 Days</option>
          </select>
        </div>

        <DataTable data={logs} columns={columns} data-id="element-131" />
      </div>

      {/* Role Permissions Matrix */}
      <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-100" data-id="element-132">
        <h3 className="text-lg font-bold text-slate-800 mb-4 flex items-center gap-2" data-id="element-133">
          <Lock size={20} className="text-slate-500" data-id="element-134" />
          Role Permissions Matrix
        </h3>
        <div className="overflow-x-auto" data-id="element-135">
          <table className="w-full text-left border-collapse" data-id="element-136">
            <thead data-id="element-137">
              <tr className="bg-slate-50 border-b border-slate-200" data-id="element-138">
                <th className="px-4 py-3 text-xs font-semibold text-slate-500 uppercase" data-id="element-139">
                  Role
                </th>
                {permissionNames.map((perm, idx) => <th key={idx} className="px-4 py-3 text-xs font-semibold text-slate-500 uppercase text-center" data-id="element-140">
                    {perm}
                  </th>)}
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-141">
              {roles.map((role, idx) => <tr key={idx} className="hover:bg-slate-50/50" data-id="element-142">
                  <td className="px-4 py-3 font-medium text-slate-900" data-id="element-143">
                    {role.name}
                  </td>
                  {role.permissions.map((hasPerm, pIdx) => <td key={pIdx} className="px-4 py-3 text-center" data-id="element-144">
                      {hasPerm ? <Check size={16} className="text-green-500 mx-auto" data-id="element-145" /> : <X size={16} className="text-slate-300 mx-auto" data-id="element-146" />}
                    </td>)}
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}